var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 468 468",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.59 137.835c-6.737 0-14.101 2.42-19.184 8.155-6.657 7.51-8.744 29.953-8.497 41.279 11.24.272 32.73-.026 41.436-8.683 9.103-9.053 11.594-24.872 1.914-34.499-4.213-4.19-9.838-6.252-15.669-6.252zM106.795 137.835c6.737 0 14.101 2.42 19.184 8.155 6.657 7.51 8.744 29.953 8.497 41.279-11.24.272-32.731-.026-41.436-8.683-9.103-9.053-11.594-24.872-1.914-34.499 4.213-4.19 9.838-6.252 15.669-6.252z",
    fill: "#8BA4BF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.471 122.834c17.093 16.996 19.37 43.784 7.659 64.435H468v-75.412C468 88.188 448.777 69 425.065 69H164.699v46.273c21.042-11.873 47.63-9.484 64.772 7.561 9.738 9.683-17.142-17.045 0 0zM101.719 271.619l-21.301-21.163 33.093-33.187H0v138.873C0 379.812 19.223 399 42.935 399h91.709V238.601zM185.7 217.269l32.652 32.913-21.356 21.108-32.297-32.555V399h260.366C448.777 399 468 379.812 468 356.143V217.269zM62.213 187.269c-11.713-20.654-9.432-47.44 7.659-64.435 17.141-17.045 43.729-19.433 64.772-7.561V69H42.935C19.223 69 0 88.188 0 111.857v75.412z",
    fill: "#8BA4BF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.7024ebca7052d8af27415c60782b6b35.svg";
export { ForwardRef as ReactComponent };